import axios from 'axios';
import api from './api';
import ToastHelper from '../utils/toastHelper';
import { UPLOAD_ROUTE } from '../constants/apiRoutes';

export default {
	uploadDocumento(documento) {
		const dataForm = new FormData();
		dataForm.append('arquivo', documento[0].file);

		return api.post(UPLOAD_ROUTE.UPLOAD_ARQUIVO, dataForm);
	},

	/* Metodo para upload de arquivo segundo a documentação do FilePond */
	handleUploadFilePond(
		fieldName,
		file,
		metadata,
		load,
		error,
		progress,
		abort,
		context,
		onUpload,
		valuesFormik,
	) {
		const formData = new FormData();
		formData.append('arquivo', file);

		// relacionado ao cancelamento da request
		const { CancelToken } = axios;
		const source = CancelToken.source();

		// request
		api.post(UPLOAD_ROUTE.UPLOAD_ARQUIVO, formData, {
			cancelToken: source.token,
			onUploadProgress: (e) => {
			// indicador de progresso usado no componente de upload
				progress(e.lengthComputable, e.loaded, e.total);
			},
		}).then((response) => {
			load(response.data.data.id);
			onUpload(response, valuesFormik);
		}).catch((thrown) => {
			if (axios.isCancel(thrown)) {
				ToastHelper.error('O upload foi cancelado.');
			} else {
				ToastHelper.error('Houve um problema com o upload.');
			}
		});

		return {
		// Função para tratar o clique no botão de cancelamento da request
			abort: () => {
				source.cancel('Operation cancelled by the user.');
			},
		};
	},
};
